import React from "react";
import Modal from "react-bootstrap/Modal";
import { DataGrid } from '@mui/x-data-grid';
import Button from "react-bootstrap/Button";

export default function LogisticStationList({
  _logisticStationList,
  showLogisticStationList,
  setShowLogisticStationList,
  logisticStationFieldName,
  onChange,
  
}) {


  function handleOnSelect(selectedId) {
    onChange({
      target: { value: selectedId[0], name: logisticStationFieldName, type: "text"  },
    });
    setShowLogisticStationList(false);
  } 
  return (
    <Modal
      show={showLogisticStationList}
      size="xl"
      onHide={() => setShowLogisticStationList(false)}
      dialogClassName="modal-90w modal-dialog-scrollable"
      aria-labelledby="example-custom-modal-styling-title"
      className="partner-list-modal"
    >
      <Modal.Header
        style={{
          background: "#d4e1f5",
        }}
      >
        <Modal.Title
          id="example-custom-modal-styling-title"
          style={{
            fontWeight: 700,
          }}
        >
          List of Logistic Stations
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {_logisticStationList?.length && (
          <div style={{ height: '50vh', width: '100%' }}>
         <DataGrid
         rows={_logisticStationList || []}
         columns={[
          { field: 'id', headerName: 'LogisticStation ID', width: 250 },
          { field: 'logisticStationTypeId', headerName: 'Logistic Station Type', width: 250 },
          { field: 'name', headerName: 'Name', width: 350 },
         ]}
         pageSize={10}
         rowsPerPageOptions={[5]}
         onSelectionModelChange={selectedId => handleOnSelect(selectedId)}
       />
       </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="offset-11 col-1">
          <Button
            variant="danger"
            onClick={() => {
              setShowLogisticStationList(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
